module.exports = __webpack_public_path__ + "img/airplane-ticket@2x.700a61b1.png";